import Autocomplete from "./Autocomplete";
import { notNullOrUndefined } from "@/utility/functions";

export default {
  mixins: [Autocomplete],
  computed: {
    localValue: {
      get() {
        return notNullOrUndefined(this.value) ? this.value : [];
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    showCounter() {
      return this.counter != null ? this.counter : true;
    },
    handleInitialValueAllowed() {
      return notNullOrUndefined(this.value) && Array.isArray(this.value) && this.value.length !== 0;
    }
  },
  methods: {
    async loadItems(search, queryParam) {
      this.loading = true;
      const loadedItems = await this.listApi(search, queryParam);
      this.clearItems();
      this.items = this.items.concat(loadedItems);
      this.loading = false;
    },
    buildInitialValueQueryParam() {
      let initialQueryParam = "";
      for (const element of this.value) {
        const elementId = this.returnObject ? element[this.itemValue] : element;
        initialQueryParam = initialQueryParam + this.idPredicatePath + "=" + elementId + "&";
      }
      return initialQueryParam;
    },
    clearItems() {
      console.log("yolo");
      if (this.value) {
        console.log(this.items);
        this.items = this.items.filter(item =>
          this.value.map(value => (this.returnObject ? value.id : value)).includes(item.id)
        );
        console.log(this.items);
      } else {
        this.items = [];
      }
    },
    emitInputObject() {
      const selectedItems = [];
      for (const subValue of this.value) {
        const selectedItem = this.items.find(item => item[this.itemValue] === subValue);
        selectedItems.push(selectedItem);
      }
      this.$emit("inputObject", selectedItems);
    }
  }
};
